import React from 'react';

//component
import WmsButton from '../../../components/WmsButton/WmsButton.jsx';
import WmsModel from '../../../components/WmsModel/WmsModel.jsx';
import WmsDropdown from '../../../components/WmsDropdown/WmsDropdown.jsx';
import WmsCollapse from '../../../components/WmsCollapse/WmsCollapse.jsx';
import WmsInput from '../../../components/WmsInput/WmsInput.jsx';

import * as findOrdersService from '../findOrders.services.jsx';
import * as GlobalService from '../../../global_services';
import { _ } from "../../../global_variable_service.jsx";
import style from './orders-hold.scss';

export class HoldOrdersModel extends React.Component {

    constructor(props) {
        super(props);

        this.translate = window.translate;
        this._isMounted = false;

        this.state = {
            selector: 'FindOrders',
            holdOrdersLoader: false,
            holdReasonOptions: [],
            selectedHoldReason: '',
            otherHoldReason: '',
            unallocateOrders: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
        let holdReasonArr = this.translate('Orders_HoldOrders_Reason_Options').split(',');
        let holdReasonOptions = [];
        (holdReasonArr).forEach((value, index) => {
            let trimmedValue = value.trim();
            // Skip empty values (which come from leading comma)
            if (trimmedValue !== '') {
                holdReasonOptions.push({ "Name": trimmedValue, "Value": trimmedValue });
            }
        });
        this.setState({
            holdReasonOptions: holdReasonOptions,
            otherHoldReason: ''
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ selectedHoldReason: '' });
    }

    holdReasonChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleCheckboxChange = (e) => {
        this.setState({ [e.target.name]: e.target.checked });
    }

    holdOrders = () => {
        this.setState({ holdOrdersLoader: true });

        let holdData = {
            'reason': this.state.selectedHoldReason == 'Other' ? (this.state.selectedHoldReason + ' - ' + this.state.otherHoldReason) : this.state.selectedHoldReason,
            'orderIds': this.props.selectedOrderIds,
            'deallocate': this.state.unallocateOrders
        };

        findOrdersService.holdOrders(holdData).then((response) => {
            // Check if response data exists and has IsSuccess property
            const responseData = response && response.data ? response.data : response;
            if (responseData && responseData.IsSuccess) {
                // Close modal
                this.props.onCancel();

                // Show success notification
                GlobalService.notification('success', this.translate('Orders_HoldOrders_Success'));

                // Reset grid selection
                if (this.props.onResetGridSelection) {
                    this.props.onResetGridSelection();
                }
            } else {
                const errorMessage = responseData && responseData.ErrorMessage ? responseData.ErrorMessage : this.translate('Orders_HoldOrders_Error');
                GlobalService.notification('error', errorMessage);
            }
        }).catch((error) => {
            console.error('Hold orders error:', error);
            GlobalService.notification('error', this.translate('Orders_HoldOrders_Error'));
        }).finally(() => {
            if(this._isMounted) {
                this.setState({ holdOrdersLoader: false });
            }
        });
    }

    render() {
        return (
            <WmsModel
                id={'holdOrders_' + (this.props.windowId || 'default')}
                title={this.translate('Label_Hold_Orders')}
                width={800}
                height={201}
                onCloseFunc={this.props.onCancel}
                isOpen={this.props.isOpen}
                customClass='wms-model-new-ui-wrapper'
                class="orders-hold-reason-model-wrapper">

                <div className="model-content-wrapper">
                    <div className="hold-orders-intro">
                        <p>{this.translate('Orders_HoldOrders_Intro')}</p>
                    </div>

                    <WmsCollapse
                        id={'manageOrdersReasonForHold'}
                        headerLabel={this.translate('Label_Reason_for_Hold')}
                        showCollapseText={false}
                        showCollapseIcon={false}>

                        <WmsDropdown
                            id="selectedHoldReason"
                            windowId={this.props.windowId}
                            name="selectedHoldReason"
                            label={this.translate('Label_Reason_for_Hold')}
                            wmsSelector={this.state.selector + "HoldOrdersReason"}
                            value={this.state.selectedHoldReason}
                            onChangeFunc={this.holdReasonChange}
                            options={this.state.holdReasonOptions}
                            blankFirstOption={true}
                            blankFirstOptionText="Unspecified"
                            textField='Name'
                            valueField='Value' />

                        <WmsInput
                            id="otherHoldReason"
                            inputName="otherHoldReason"
                            label={this.translate('Orders_HoldOrders_Label_Other')}
                            value={this.state.otherHoldReason}
                            disabled={this.state.selectedHoldReason !== 'Other'}
                            extraWrapperClass={this.state.selectedHoldReason !== 'Other' ? 'disable-input' : ''}
                            onChangeFunc={this.holdReasonChange}
                            wmsSelector={this.state.selector + "otherHoldReason"}
                            maxLength={240}
                        />

                    </WmsCollapse>

                    <WmsCollapse
                        id={'manageAllocatedInventory'}
                        headerLabel={this.translate('Label_Manage_Allocated_Inventory')}
                        showCollapseText={false}
                        showCollapseIcon={false}>

                        <div className="checkbox-section">
                            <label className="wms-checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    name="unallocateOrders"
                                    className="k-checkbox"
                                    checked={this.state.unallocateOrders}
                                    onChange={this.handleCheckboxChange}
                                />
                                <span className="k-checkbox-label">
                                    {this.translate('Orders_HoldOrders_Label_Unallocate')}
                                </span>
                            </label>
                        </div>

                    </WmsCollapse>
                </div>

                <div className="footer-btn-holder">
                    <WmsButton
                        label={this.translate("Label_Cancel")}
                        wmsSelector={this.state.selector + "ExitButton"}
                        onClickFunc={this.props.onCancel}
                        icon="fa-ban"
                        buttonType="orange"
                        disabled={this.state.holdOrdersLoader}
                        loading={this.state.holdOrdersLoader}
                    />

                    <WmsButton
                        label={this.translate('Label_Confirm')}
                        wmsSelector={this.state.selector + "HoldOrdersButton"}
                        onClickFunc={this.holdOrders}
                        icon='fa-floppy-o'
                        disabled={
                            this.state.selectedHoldReason == '' ||
                            this.state.selectedHoldReason == null ||
                            this.state.holdOrdersLoader ||
                            (this.state.selectedHoldReason == 'Other' && this.state.otherHoldReason.trim() == '')
                        }
                        loading={this.state.holdOrdersLoader} />
                </div>
            </WmsModel>
        );
    }
}
